export default {
      id: "illness-40-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#illness-40",
      toString: function () {
        return this.url;
      }
    }